module.exports = __webpack_public_path__ + "img/img36.82f2a6b1.svg";